import { isEmpty } from "lodash";

// Returns format as a=b&c=d
export const getSearchParams = (
    additionalSearchParams: { [key: string]: string } = {},
    removeSearchParams: string[] = [],
): string => {
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    for (const param of removeSearchParams) {
        searchParams.delete(param);
    }

    if (isEmpty(additionalSearchParams)) {
        if (isEmpty(url.searchParams.toString())) {
            return "";
        }
        return `?${url.searchParams.toString()}`;
    }

    Object.entries(additionalSearchParams).forEach(([name, value]) => {
        if (!searchParams.has(name)) {
            searchParams.append(name, value);
        }
    });

    return `?${searchParams.toString()}`;
};

export const getSearchParamsAndOverride = (
    overrideSearchParams: { [key: string]: string } = {},
    removeSearchParams: string[] = [],
): string => {
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;

    for (const param of removeSearchParams) {
        searchParams.delete(param);
    }

    if (isEmpty(overrideSearchParams)) {
        if (isEmpty(url.searchParams.toString())) {
            return "";
        }
        return `?${url.searchParams.toString()}`;
    }

    Object.entries(overrideSearchParams).forEach(([name, value]) => {
        if (!searchParams.has(name)) {
            searchParams.append(name, value);
        } else {
            searchParams.set(name, value);
        }
    });

    return `?${searchParams.toString()}`;
};
